// extracted by mini-css-extract-plugin
export default {"link-button":"SquareButton_link-button__WLmS8"};